document.addEventListener("DOMContentLoaded", function (event) {
  var catPCElement = document.querySelector(".desktop-image__banner.cat");
  var catSPElement = document.querySelector(".mobile-image__banner.cat");

  if (window.innerWidth > 750) {
    catPCElement.classList.add("on");
  } else {
    catSPElement.classList.add("on");
  }
  var catTextElement = document.querySelector(
    ".banner-concept__text-about-cat"
  );
  catTextElement.classList.add("on");

  var rellax = new Rellax(".js-rellax", {
    speed: -2,
    wrapper: null,
    round: true,
  });
});

window.addEventListener("resize", function (event) {
  var catPCElement = document.querySelector(".desktop-image__banner.cat");
  var catSPElement = document.querySelector(".mobile-image__banner.cat");
  if (window.innerWidth > 750) {
    catPCElement.classList.add("on");
  } else {
    catSPElement.classList.add("on");
  }
});

// KVのテキスト表示切り替え
window.onscroll = function () {
  var catText1Element = document.querySelector(
    ".banner-concept__text-about-cat.text1"
  );
  var catText2Element = document.querySelector(
    ".banner-concept__text-about-cat.text2"
  );
  if (window.innerWidth > 750) {
    if (window.scrollY > 50) {
      catText1Element.classList.remove("on");
      catText2Element.classList.add("on");
    } else {
      catText1Element.classList.add("on");
      catText2Element.classList.remove("on");
    }
  } else {
    if (window.scrollY > 20) {
      catText1Element.classList.remove("on");
      catText2Element.classList.add("on");
    } else {
      catText1Element.classList.add("on");
      catText2Element.classList.remove("on");
    }
  }
};

/**
 * 交差したときに呼び出す関数
 * @param entries
 */
function doWhenIntersect(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add("on");
    }
  });
}
const options = {
  root: null, // 今回はビューポートをルート要素とする
  rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
  threshold: 0 // 閾値は0
};
const observer = new IntersectionObserver(doWhenIntersect, options);

observer.observe(document.getElementById("about-skincare"));
observer.observe(document.getElementById("about-haircare"));
observer.observe(document.getElementById("about-handcare"));
observer.observe(document.getElementById("about-bodycare"));
observer.observe(document.getElementById("about-fragrance"));